export default "__VITE_ASSET__De8Z7hlJ__"